











































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';
import SearchIcon from 'mdi-vue/Magnify';
import ExportIcon from 'mdi-vue/FileExportOutline';
import DownloadIcon from 'mdi-vue/Download';
import { mapState } from 'vuex';
// import papa from 'papaparse';
// import excel from 'exceljs';
import api from '@/libs/api';
import { User } from '@/libs/api.interfaces';
import FormInput from '@/components/FormInput.vue';
import VueMonthlyPicker from 'vue-monthly-picker';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import TagInput from '@/components/TagInput.vue';
import Toggle from '@/components/Toggle.vue';
import Table from '@/components/Table/Table.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import Tab from '@/components/Tab/Tab.vue';
import SummaryBox from '@/components/SummaryBox.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import Select from '@/components/Select.vue';
import DatePicker, { DateRange } from '@/components/DatePicker.vue';
import hasPermission from '@/libs/permission';
import excel from 'exceljs';
import { AxiosError } from 'axios';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import BulkInvoiceReportTable from './BulkInvoiceReportTable.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    TagInput,
    Toggle,
    Table,
    Row,
    Header,
    SubHeader,
    Cell,
    Checkbox,
    FormInput,
    Loader,
    Button,
    Tab,
    SummaryBox,
    SearchIcon,
    ExportIcon,
    DownloadIcon,
    VueMonthlyPicker,
    DatePicker,
    SearchField,
    SearchRow,
    Select,
    BulkInvoiceReportTable,
  },
  computed: mapState(['user']),
  methods: {
    hasPermission,
  },
})
export default class BulkInvoiceReport extends Vue {
  user!: {
    user: User;
  };

  loadingExport = false;

  searchOpen = false;
  selectedCount = 0;

  startperiode = '';
  endperiode = '';
  paymentStart = '';
  paymentEnd = '';
  transactionNumber = '';
  email = '';
  phoneNumber = '';
  paymentStatus: LabelValue | null = null;
  status = '';

  transactionDate: DateRange = {
    startDate: dayjs(Date()).subtract(7, 'day').format('MM/DD/YYYY'),
    endDate: dayjs(Date()).format('MM/DD/YYYY'),
  }

  paymentDate: DateRange = {
    startDate: null,
    endDate: null,
  }

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;

  $refs!: {
    report: BulkInvoiceReportTable;
  }

  // format!: (val: string) => string;
  // hasPermission!: (val: string) => boolean;

  paymentStatusOptions = [
    {
      label: 'All',
      value: 'all',
    },
    {
      label: 'Paid',
      value: '00',
    },
    {
      label: 'Unpaid',
      value: '01',
    },
    {
      label: 'Expired',
      value: '03',
    },
    {
      label: 'Cancelled',
      value: '04',
    },
  ]

  urls = false;
  // checkURL(val: any) {
  //   if (val === 0) {
  //     this.urls = false;
  //   } else {
  //     this.urls = true;
  //   }
  // }

  toggleSearchOpen() {
    this.searchOpen = !this.searchOpen;
  }

  mounted() {
    this.parseParams();
    // this.paymentStatus = this.paymentStatusOptions['0'];
  }

  @Watch('$route')
  onRouteChange() {
    this.parseParams();
  }

  search() {
    const td = this.transactionDate.startDate === null || this.transactionDate.endDate === null ? undefined : {
      start: dayjs(this.transactionDate.startDate).format('MM/DD/YYYY'),
      end: dayjs(this.transactionDate.endDate).format('MM/DD/YYYY'),
    };

    const pd = this.paymentDate.startDate === null || this.paymentDate.endDate === null ? undefined : {
      start: dayjs(this.paymentDate.startDate).format('MM/DD/YYYY'),
      end: dayjs(this.paymentDate.endDate).format('MM/DD/YYYY'),
    };
    // var startTime = td.start;
    // var endTime = td.end;
    // console.log(td && `${td.start},${td.end}`);
    // console.log(this.user.user);
    this.$router.push({
      query: {
        // td: td && `${td.start},${td.end}`,
        sd: td && `${td.start}`,
        ed: td && `${td.end}`,
        pds: pd && `${pd.start}`,
        pde: pd && `${pd.end}`,
        tn: this.transactionNumber === null ? undefined : this.transactionNumber,
        em: this.email === null ? undefined : this.email,
        pn: this.phoneNumber === null ? undefined : this.phoneNumber,
        ps: this.paymentStatus === null ? undefined : this.paymentStatus.value,
      },
    });
  }

  reset() {
    this.transactionDate = {
      startDate: dayjs(Date()).subtract(7, 'day').format('MM/DD/YYYY'),
      endDate: dayjs(Date()).format('MM/DD/YYYY'),
    };
    this.paymentDate = {
      startDate: null,
      endDate: null,
    };
    this.startperiode = dayjs(Date()).subtract(7, 'day').format('MM/DD/YYYY');
    this.endperiode = dayjs(Date()).format('MM/DD/YYYY');
    this.paymentStart = '';
    this.paymentEnd = '';
    this.transactionNumber = '';
    this.email = '';
    this.phoneNumber = '';
    this.status = 'all';
    this.paymentStatus = null;

    this.$router.push({
      query: {},
    });
  }

  parseParams() {
    // const today = new Date();
    // const lastweek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
    const params = this.$route.query;
    // console.log(this.$route.query);
    if (typeof params.sd === 'string') {
      const startDate = params.sd.toString();
      if (startDate) {
        this.startperiode = startDate;
      } else {
        this.startperiode = '';
      }
    }

    if (typeof params.ed === 'string') {
      const endDate = params.ed.toString();
      if (endDate) {
        this.endperiode = endDate;
      } else {
        this.endperiode = '';
      }
    }

    if (typeof params.pds === 'string') {
      const startDate = params.pds.toString();
      if (startDate) {
        this.paymentStart = startDate;
      } else {
        this.paymentStart = '';
      }
    }

    if (typeof params.pde === 'string') {
      const endDate = params.pde.toString();
      if (endDate) {
        this.paymentEnd = endDate;
      } else {
        this.paymentEnd = '';
      }
    }

    if (typeof params.tn === 'string') {
      const transactionNumber = params.tn.toString();
      if (transactionNumber) {
        this.transactionNumber = transactionNumber;
      } else {
        this.transactionNumber = '';
      }
    }

    if (typeof params.em === 'string') {
      const email = params.em.toString();
      this.email = email;
    } else {
      this.email = '';
    }

    if (typeof params.pn === 'string') {
      const phoneNumber = params.pn.toString();
      this.phoneNumber = phoneNumber;
    } else {
      this.phoneNumber = '';
    }

    if (typeof params.ps === 'string') {
      const paymentStatus = params.ps.toString();
      if (paymentStatus) {
        this.status = paymentStatus;
      } else {
        this.status = '';
      }
    }
    // console.log(params.page);
    let page = 1;
    if (typeof params.page === 'string') {
      page = Number(params.page);
    }

    this.getBulkInvoive(page);
  }

  async getBulkInvoive(page: number) {
    const params = {
      startperiode: this.startperiode,
      endperiode: this.endperiode,
      paymentstart: this.paymentStart,
      paymentend: this.paymentEnd,
      transactionNumber: this.transactionNumber,
      email: this.email,
      phoneNumber: this.phoneNumber,
      status: this.status,
    };
    await this.$refs.report.getBulkInvoive(params, page);
  }

  async exportData() {
    /* eslint-disable */
    this.loadingExport = true;
    const transactionNumber = this.transactionNumber.length === 0 ? undefined : this.transactionNumber;
    const email = this.email.length === 0 ? undefined : this.email;
    const phoneNumber = this.phoneNumber.length === 0 ? undefined : this.phoneNumber;
    const status = this.status === '' ? 'all' : this.status;
    try {
      const { data } = await api.get('easyinvoice/invoices_list_bulk_download', {
        params: {
          start_date_upload: this.startperiode,
          end_date_upload: this.endperiode,
          start_date_payment: this.paymentStart,
          end_date_payment: this.paymentEnd,
          status: status,
          user_group: 5,
          user_id: this.user.user.id,
          phone: phoneNumber,
          transaction_number: transactionNumber,
          emailcustomer: email,
        },
      });
      const workbook = new excel.Workbook();
      workbook.created = dayjs().toDate();
      const sheet = workbook.addWorksheet('Report', { views: [{ state: 'frozen', ySplit: 1 }] });
      sheet.getRow(1).font = { bold: true };
      sheet.columns = [
        { header: 'Invoice ID', width: 18 },
        { header: 'Customer Name', width: 18 },
        { header: 'Email CS', width: 27 },
        { header: 'Amount', width: 18 },
        { header: 'Phone Number', width: 14 },
        { header: 'Transaction Date', width: 18 },
        { header: 'Transaction Expire', width: 18 },
        { header: 'Status', width: 14 },
        { header: 'Expired Duration', width: 18 },
        { header: 'Payment', width: 18 },
        { header: 'Transaction Number', width: 20 },
        { header: 'Approval Code', width: 18 },
        { header: 'CS Name', width: 18 },
      ];
      data.forEach((item: any) => {
        sheet.addRow([
          item.inv_id,
          item.name,
          item.email_cs,
          item.amount,
          item.phone,
          item.timestamp,
          item.expiry,
          item.status,
          item.expired_duration,
          item.payment_channel,
          item.transno,
          item.approval_code,
          item.first_name,
        ]);
      });
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer]);
      const fileURL = window.URL.createObjectURL(blob);
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;
      const filename = `'Report-bulk-invoice'-${new Date().toLocaleDateString()}.xlsx`;
      fileLink.setAttribute('download', filename);
      document.body.appendChild(fileLink);
      fileLink.click();
      this.loadingExport = false;
      showToast(ToastType.SUCCESS, 'Export Report', 'Export finished');
    } catch (err) {
      this.loadingExport = false;
      showToast(ToastType.FAILED,
        `Error [${(err as AxiosError).response?.status}]`, 'Failed to export Report');
    }
    /* eslint-enable */
  }
}
